@if (calculatedMode() === 'list') { @if (listButtons(); as listButtons) { @if (listButtons.length) {
<div libFlexRow [libFlexRowAlign]="'start'">
	<div libFlexColumn [libFlexSize]="useFullSizeButtons() ? 'fill' : undefined">
		<div [libFlexRow]="true" [libFlexRowGap]="buttonsListRowGap()" [libFlexRowAlign]="'start'">
			@for (button of listButtons; track trackByButton($index, button)) {

			<div libFlexColumn [libFlexSize]="buttonColumnFlexSize()">
				<lib-button
					[buttonSize]="button.buttonSize"
					[iconOnly]="button.iconOnly ?? false"
					[disabled]="button.disabled?.() ?? false"
					[buttonType]="button.buttonType"
					(click)="handleButtonClick($event, button)"
					[routerLink]="button.routerLink"
					[icon]="button.icon"
					[iconLocation]="button.iconLocation"
					[nestedButtons]="button.nestedButtons"
					[tooltip]="getTooltip(button)"
					>{{ button.title }}</lib-button
				>
			</div>

			}
		</div>
	</div>
</div>
} } } @if (calculatedMode() === 'block') { @if (listButtons(); as listButtons) { @if (listButtons.length) { @for (button
of listButtons; track trackByButton($index, button); let first = $first) {
<div libFlexRow [libFlexRowAlign]="'start'" [class.push-top]="!first">
	<div libFlexColumn [libFlexSize]="buttonColumnFlexSize()">
		<lib-button
			[buttonSize]="button.buttonSize"
			[iconOnly]="button.iconOnly ?? false"
			[disabled]="button.disabled?.() ?? false"
			[buttonType]="button.buttonType"
			(click)="handleButtonClick($event, button)"
			[routerLink]="button.routerLink"
			[icon]="button.icon"
			[iconLocation]="button.iconLocation"
			[nestedButtons]="button.nestedButtons"
			[tooltip]="getTooltip(button)"
			>{{ button.title }}</lib-button
		>
	</div>
</div>
} } } } @if (calculatedMode() === 'extendedList') { @if (extendedListButtons(); as extendedListButtons) {
<ng-container>
	@if (extendedListButtons.primaryButtons.length || extendedListButtons.singleButtons.length) {
	<div>
		<div [libFlexRow]="true" [libFlexRowGap]="extendedButtonsListRowGap()" [libFlexRowAlign]="'space-between'">
			@if (extendedListButtons.primaryButtons.length) {
			<div libFlexColumn [libFlexSize]="buttonColumnFlexSize()">
				<div libFlexRow [libFlexRowGap]="buttonsListRowGap()" [libFlexRowAlign]="'center'">
					@for ( button of extendedListButtons.primaryButtons; track trackByButton($index, button); let first
					= $first) {
					<div libFlexColumn [libFlexSize]="buttonColumnFlexSize()">
						<lib-button
							[iconLocation]="button.iconLocation"
							[buttonSize]="button.buttonSize"
							[iconOnly]="button.iconOnly ?? false"
							[disabled]="button.disabled?.() ?? false"
							[buttonType]="button.buttonType"
							(click)="handleButtonClick($event, button)"
							[routerLink]="button.routerLink"
							[icon]="first || button.iconOnly ? button.icon : undefined"
							[nestedButtons]="button.nestedButtons"
							[tooltip]="getTooltip(button)"
							>{{ button.title }}</lib-button
						>
					</div>
					} @if(showExtendedListMorelabel()) {
					<div libFlexColumn libText4>
						+ {{ extendedListButtons.singleButtons.length }}{{ isMobileView() ? '' : ' more' }}
					</div>
					}
				</div>
			</div>
			} @if (extendedListButtons.singleButtons.length) {
			<div libFlexColumn>
				<lib-tooltip-menu #buttonsMenu>
					@for (button of extendedListButtons.singleButtons; track trackByButton($index, button); let first =
					$first; let last = $last) {

					<div>
						<lib-tooltip-menu-item
							[isFirst]="first"
							[isLast]="last"
							[confirmMode]="button.confirm?.confirmMode"
							[confirmText]="button.confirm?.text"
							[confirmTitle]="button.confirm?.title"
							(itemClick)="handleButtonClick($event, button)"
							[routerLink]="button.routerLink"
							[disabled]="button.disabled?.()"
							[title]="button.title"
							[typeIcon]="button.icon"
							[itemDesign]="button.confirm?.confirmMode === 'delete' ? 'delete' : 'default'"
						></lib-tooltip-menu-item>
					</div>

					}
				</lib-tooltip-menu>

				<lib-button
					[libTooltipMenu]="buttonsMenu"
					[iconOnly]="true"
					[tooltip]="isMobileView() ? undefined : singleButtonTooltip()"
					[tooltipLocation]="singleButtonTooltipLocation()"
					[icon]="moreIcon()"
				>
				</lib-button>
			</div>
			}
		</div>
	</div>
	}
</ng-container>
} } @if (calculatedMode() === 'single') { @if (singleButtons(); as singleButtons) { @if (singleButtons.length) {

<lib-tooltip-menu #buttonsMenu>
	@for (button of singleButtons; track trackByButton($index, button); let first = $first; let last = $last) {

	<div>
		<lib-tooltip-menu-item
			[isFirst]="first"
			[isLast]="last"
			(itemClick)="handleButtonClick($event, button)"
			[routerLink]="button.routerLink"
			[disabled]="button.disabled?.()"
			[title]="button.title"
			[typeIcon]="button.icon"
			[confirmMode]="button.confirm?.confirmMode"
			[confirmText]="button.confirm?.text"
			[confirmTitle]="button.confirm?.title"
			[itemDesign]="button.confirm?.confirmMode === 'delete' ? 'delete' : 'default'"
		></lib-tooltip-menu-item>
	</div>

	}
</lib-tooltip-menu>

<lib-button
	[buttonType]="singleButtonType()"
	[libTooltipMenu]="buttonsMenu"
	[iconOnly]="true"
	[tooltip]="isMobileView() ? undefined : singleButtonTooltip()"
	[tooltipLocation]="singleButtonTooltipLocation()"
	[icon]="moreIcon()"
>
</lib-button>

} } }
